<div class="PGFilterEditor container-fluid">

    @if (!adminMode) {
        <app-pg-filter-editor-search [resourceId]="resourceId" [status]="status" [appliedFilter]="appliedFilter" [hasTags]="hasTags" [hasSystemTags]="hasSystemTags" [categoriesField]="categoriesField" [categoriesOptions]="categoriesOptions" (applySearch)="doApplySearch(true)"></app-pg-filter-editor-search>
        @if (canFilterSomething && !disableAdvancedFilters) {
            <div class="row mt-2">
                <div class="col-12 PGFilterEditor-Advanced">
                    <button class="btn btn-sm {{hasAdvancedFilters ? 'btn-primary' : 'btn-secondary'}}" (click)="toggleAdvancedFilters()">
                        <i class="fa-regular fa-filter fa-fw"></i><span>{{ 'pg-filter-editor.advanced-filters' | locTranslate }}</span>
                    </button>
                </div>
            </div>
        }
    }

    @if (!editFilter && hasAppliedFilter()) {
        <div class="row">
            <div class="col PGFilterEditor-Applied">
                <h4 class="mb-0 mt-2">{{ 'pg-filter-editor.section-filter' | locTranslate }}</h4>
                @for (byResource of appliedFilterByResource; track byResource) {
                    @if (byResource.id != resourceId) {
                        <div class="PGFilterEditor-Applied-Resource">{{byResource.name}}</div>
                    }
                    <div [innerHTML]="getResourceFilterString(byResource)"></div>
                }
            </div>
        </div>
    }
    @if (!editOrder && hasAppliedOrder()) {
        <div class="row">
            <div class="col PGFilterEditor-Applied">
                <h4 class="mb-0 {{ hasAppliedFilter() ? 'mt-0' : 'mt-2' }}">{{ 'pg-filter-editor.section-order' | locTranslate }}</h4>
                <div>{{getOrderString(appliedOrder)}}</div>
            </div>
        </div>
    }
    @if (editFilter) {
        <div class="row">
            <div class="col">
                <h4 class="mt-3 mb-2">{{ 'pg-filter-editor.section-filter' | locTranslate }}</h4>
                <div class="container-fluid py-2 my-2 border-top">
                    <div class="PGFilterEditor-Header row pb-1">
                        <div class="col PGFilterEditor-Element-Field">{{ 'pg-filter-editor.filter-field' | locTranslate }}</div>
                        <div class="col PGFilterEditor-Element-Operator">{{ 'pg-filter-editor.filter-operator' | locTranslate }}</div>
                        <div class="col PGFilterEditor-Element-Value">{{ 'pg-filter-editor.filter-value' | locTranslate }}</div>
                        <div class="col PGFilterEditor-Element-Actions"></div>
                    </div>
                    @for (byResource of filterByResource; track byResource) {
                        @if (byResource.id != resourceId) {
                            <div class="PGFilterEditor-Resource row my-2">
                                <div class="col">{{byResource.name}}</div>
                            </div>
                        }
                        @for (filter of byResource.list; track filter) {
                            <div class="PGFilterEditor-Element row pb-1">
                                <div class="col PGFilterEditor-Element-Field">
                                    <app-pg-select [options]="configByResource[byResource.id].fieldOptions" display="oneLine"
                                    [readonly]="filter.readonly" [(ngModel)]="filter.field" (ngModelChange)="onFilterFieldChange(filter)"></app-pg-select>
                                </div>
                                <div class="col PGFilterEditor-Element-Operator">
                                    @if (filter.field != null) {
                                        <app-pg-select [options]="configByResource[byResource.id].operatorOptionsByField[filter.field]" display="oneLine"
                                        [readonly]="filter.readonly" [(ngModel)]="filter.operator" (ngModelChange)="onFilterOperatorChange(filter)"></app-pg-select>
                                    }
                                </div>
                                <div class="col PGFilterEditor-Element-Value">
                                    @if (filter.field != null && filter.operator != null) {
                                        <div>
                                            @for (valueField of valueFields[getFilterIndex(filter)]; track valueField; let i = $index) {
                                                <app-pg-form-field
                                                    [fieldData]="valueField" [noLabel]="true" [display]="filterFieldDisplay"
                                                [(ngModel)]="filter.value[i]" (ngModelChange)="onFilterValueChange(filter)"></app-pg-form-field>
                                            }
                                        </div>
                                    }
                                </div>
                                <div class="col PGFilterEditor-Element-Actions">
                                    <button class="btn btn-sm btn-secondary" [hidden]="filter.readonly" (click)="removeFilter(filter)">
                                        <i class="fa-regular fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        }
                    }
                    <div class="row">
                        <div class="col">
                            <div class="PGFilterEditor-Footer border-top pt-2 mt-1">
                                <span>{{ 'pg-filter-editor.add-filter' + (hasMultipleResourceOptions ? '-on' : '') | locTranslate }}</span>
                                @if (hasMultipleResourceOptions) {
                                    <app-pg-select [options]="resourceOptions" display="oneLine" [(ngModel)]="resourceSelection" [required]="true"></app-pg-select>
                                }
                                <button class="btn btn-sm btn-primary" (click)="addFilter()">
                                    <i class="fa-regular fa-plus"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    @if (editOrder) {
        <div class="row">
            <div class="col">
                <h4 class="my-2">{{ 'pg-filter-editor.section-order' | locTranslate }}</h4>
                <div class="py-2 my-2 border-top">
                    <div class="PGFilterEditor-Header row pb-1">
                        <div class="col PGFilterEditor-Element-Field">{{ 'pg-filter-editor.filter-field' | locTranslate }}</div>
                        <div class="col PGFilterEditor-Element-Direction">{{ 'pg-filter-editor.filter-direction' | locTranslate }}</div>
                        <div class="col"></div>
                        <div class="col PGFilterEditor-Element-Actions"></div>
                    </div>
                    @for (order of status.order; track order) {
                        <div class="PGFilterEditor-Element row pb-1">
                            <div class="col PGFilterEditor-Element-Field">
                                <app-pg-select [options]="configByResource[resourceId].fieldOptions" display="oneLine"
                                    [(ngModel)]="order.field"></app-pg-select>
                            </div>
                            <div class="col PGFilterEditor-Element-Direction">
                                <app-pg-select [options]="orderDirectionOptions" display="oneLine"
                                    [(ngModel)]="order.direction" [required]="true"></app-pg-select>
                            </div>
                            <div class="col"></div>
                            <div class="col PGFilterEditor-Element-Actions">
                                <button class="btn btn-sm btn-secondary" (click)="removeOrder(order)">
                                    <i class="fa-regular fa-trash"></i>
                                </button>
                            </div>
                        </div>
                    }
                    <div class="PGFilterEditor-Footer border-top pt-2 mt-1">
                        {{ 'pg-filter-editor.add-order' | locTranslate }}
                        <button class="btn btn-sm btn-primary" (click)="addOrder()">
                            <i class="fa-regular fa-plus"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    }
    @if (!adminMode && hasAdvancedFilters) {
        <div class="row">
            <div class="PGFilterEditor-Actions col">
                <button class="btn btn-sm btn-primary" (click)="doApplySearch()">
                    <i class="fa-regular fa-filter"></i><span>{{ 'pg-filter-editor.apply-filters' | locTranslate }}</span>
                </button>
            </div>
        </div>
    }
</div>
